/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
    Tooltip,
    TooltipBody,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

export const BattleTypeTooltip = () => (
    <Tooltip id={BattleTypeTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.battle_type_header"
                    defaultMessage="Сортировка по режиму боя"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.battle_type_body"
                defaultMessage="Показать статистику игроков в выбранном режиме боя."
            />
        </TooltipBody>
    </Tooltip>
)
BattleTypeTooltip.id = 'battle-type-tooltip'


export const PersonalRatingColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.personal_rating_column_header"
                    defaultMessage="Личный рейтинг"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.personal_rating_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по личному рейтингу."
            />
        </TooltipBody>
    </div>
)
PersonalRatingColumnTooltipContent.tip = 'personal-rating-column-tooltip-tip'


export const BattlesCountColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.battles_count_column_header"
                    defaultMessage="Количество боёв"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.battles_count_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству боёв в указанном режиме за выбранный период."
            />
        </TooltipBody>
    </div>
)
BattlesCountColumnTooltipContent.tip = 'battles-count-column-tooltip-tip'


export const WinRateColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.win_rate_column_header"
                    defaultMessage="Победы"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.win_rate_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по проценту побед в указанном режиме за выбранный период."
            />
        </TooltipBody>
    </div>
)
WinRateColumnTooltipContent.tip = 'win-rate-column-tooltip-tip'


export const ExperienceColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.experience_column_header"
                    defaultMessage="Опыт"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.experience_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по среднему опыту за бой в указанном режиме за выбранный период."
            />
        </TooltipBody>
    </div>
)
ExperienceColumnTooltipContent.tip = 'experience-column-tooltip-tip'


export const DamageColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.damage_column_header"
                    defaultMessage="Урон"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.damage_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по среднему урону за бой в указанном режиме за выбранный период."
            />
        </TooltipBody>
    </div>
)
DamageColumnTooltipContent.tip = 'damage-column-tooltip-tip'


export const DaysInClanColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.days_in_clan_column_header"
                    defaultMessage="Количество дней в клане"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.days_in_clan_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству дней, проведённых в клане с момента последнего вступления в него."
            />
        </TooltipBody>
    </div>
)
DaysInClanColumnTooltipContent.tip = 'days-in-clan-column-tooltip-tip'



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Statistics/tooltips.js